import {Component, OnInit} from '@angular/core';
import {CoreConfigService} from '../../../@core/services/config.service';

@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

    constructor(public _coreConfigService: CoreConfigService) {
        this._coreConfigService.config = {
            layout: {
                menu: {
                    hidden: true
                },
                animation: 'none',
                customizer: false,
                enableLocalStorage: false,
                type: 'horizontal'
            }
        };
    }

    ngOnInit(): void {
    }

}
